/**
 * Fracture — jagged lightning-style crack running down the crown into the
 * root. Includes a bright highlight along one edge and a soft shadow to
 * give the crack a sense of depth.
 */
export default function Fracture() {
  const d = "M 30 22 L 27 34 L 32 44 L 26 56 L 33 68 L 28 82 L 32 92 L 29 108 L 33 124";
  return (
    <g style={{ pointerEvents: "none" }}>
      {/* Shadow */}
      <path d={d} fill="none" stroke="#3A0F10"
            strokeOpacity={0.55} strokeWidth={2.4} strokeLinecap="round" />
      {/* Main crack */}
      <path d={d} fill="none" stroke="#7A1E22"
            strokeWidth={1.4} strokeLinecap="round" />
      {/* Highlight */}
      <path d={d} fill="none" stroke="#FBEAD3"
            strokeOpacity={0.7} strokeWidth={0.5} strokeLinecap="round" />
      {/* Small chip flake near the incisal edge */}
      <path d="M 27 24 L 31 22 L 30 27 Z" fill="#7A1E22" opacity={0.85} />
    </g>
  );
}
